"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _textModule = _interopRequireDefault(require("./text.module.scss"));

var _mediaModule = _interopRequireDefault(require("./media.module.scss"));

var _transitionsModule = _interopRequireDefault(require("./transitions.module.scss"));

var _utilitiesModule = _interopRequireDefault(require("./utilities.module.scss"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var globalStyles = {
  text: _textModule["default"],
  media: _mediaModule["default"],
  transition: _transitionsModule["default"],
  utility: _utilitiesModule["default"]
};

var CssClassNames = /*#__PURE__*/_createClass(
/**
 * @param { [key: string]: string} CSSModulesObject - Object resulting from CSS Modules import
 * @param {string[]} defaults
 */
function CssClassNames() {
  var _this = this;

  var CSSModulesObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  _classCallCheck(this, CssClassNames);

  _defineProperty(this, "styleNames", {});

  _defineProperty(this, "keyPropName", 'className');

  _defineProperty(this, "camelize", function (str) {
    return str.replace(/\W+(.)/g, function (match, chr) {
      return chr.toUpperCase();
    });
  });

  _defineProperty(this, "className", function () {
    var cssClasses = _clsx["default"].apply(void 0, arguments);

    var obj = {};

    if (!cssClasses) {
      return obj;
    }

    obj.className = _this.getClassName(cssClasses);
    return obj;
  });

  _defineProperty(this, "cls", function () {
    var cssClasses = _clsx["default"].apply(void 0, arguments);

    if (!cssClasses) {
      return '';
    }

    return _this.getClassName(cssClasses);
  });

  _defineProperty(this, "getClassName", function (cssClasses) {
    var cls = cssClasses.replace(/\s+/g, ' ').split(/ |\n|\r/).map(function (key) {
      var style = _this.styleNames[key] || _this.styleNames[_this.camelize(key)];

      return style && typeof style === 'string' ? style : key;
    }).join(' ').trim();
    return cls;
  });

  _defineProperty(this, "getCssProp", function (props, keyProps) {
    if (typeof keyProps === 'string') {
      keyProps = [keyProps];
    }

    var cssProp = [];
    keyProps.forEach(function (keyProp) {
      switch (_typeof(props[keyProp])) {
        case 'object':
          cssProp.push(Object.keys(props[keyProp] || {}).reduce(function (css, key) {
            return props[keyProp][key] !== 'undefined' && props[keyProp][key] !== '' ? [].concat(_toConsumableArray(css), ["".concat(keyProp, "-").concat(key !== 'xs' ? "".concat(key, "-") : '').concat(props[keyProp][key])]) : css;
          }, []).join(' '));
          break;

        case 'undefined':
          break;

        default:
          cssProp.push("".concat(keyProp, "-").concat(props[keyProp]));
      }
    });
    return cssProp.join(' ');
  });

  var theStyles = {};
  defaults.forEach(function (def) {
    if (globalStyles[def]) {
      theStyles = _objectSpread(_objectSpread({}, theStyles), globalStyles[def]);
    }
  });

  if (_typeof(CSSModulesObject) === 'object') {
    theStyles = _objectSpread(_objectSpread({}, theStyles), CSSModulesObject);
  }

  this.styleNames = theStyles;
});

exports["default"] = CssClassNames;